import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { TRACEPARENT_HEADER } from '@zion/shared/observability-correlation';
import { TraceContextService } from '../../observability/trace-context.service';

export const setBaseUrlInterceptor: HttpInterceptorFn = (req, next) => {
  if (!req.url.startsWith('/api')) {
    return next(req);
  }

  const traceContextService = inject(TraceContextService);

  return next(
    req.clone({
      url: `${API_BASE_URL}${req.url}`,
      setHeaders: {
        [TRACEPARENT_HEADER]: traceContextService.createTraceparent(),
      },
    }),
  );
};
